import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useContext } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import CallToAction from '../actions/CallToAction';
import FiltersModal from '../filters/FiltersModal';
import QuickFilters from '../filters/QuickFilters';
import SearchInput from '../search/SearchInput';
import { MapMode } from '../../types';

interface SearchFiltersProps {
  handleRecenter: () => void;
  initialDeveloper: any;
  isSahel?: boolean;
}
const SearchFiltersContainer = ({
  handleRecenter,
  initialDeveloper,
  isSahel
}: SearchFiltersProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const mapMode = useSelector((state: any) => state.map.mapMode);

  const drawerOpen = useSelector((state: any) => state.map.drawerOpen);

  const { showFilters } = useContext(SearchContext) as SearchContextInterface;

  return (
    <Container>
      <div className="search-filters-bar">
        <SearchInput
          isSahel={isSahel}
          handleRecenter={handleRecenter}
          initialDeveloper={initialDeveloper}
        />
      </div>

      <QuickFilters />

      {(!showFilters || !isMobile) &&
        !(mapMode === MapMode.SEARCH && drawerOpen) && <CallToAction />}

      {showFilters && <FiltersModal />}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  position: absolute;
  top: 32px;
  display: flex;
  align-items: start;
  gap: 16px;
  padding: 0 16px;

  .search-filters-bar {
    max-width: 452px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-inline-end: 4%;
    .filters-btn {
      height: 40px;
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    flex-direction: column;
    top: 16px;

    .search-filters-bar {
      width: 100%;
      max-width: 100%;
    }
  }
`;

export default SearchFiltersContainer;
